import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// (2026-05-17) FIND-3 + FIND-7: idioma español global para DataTables
// (import de solo efecto: fija DT.defaults.language antes de renderizar tablas).
import "./utils/datatablesEs";

// Páginas públicas
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ResetPassword from "./pages/ResetPassword";

// Páginas privadas
import Dashboard from "./pages/Dashboard";
import DashboardCompras from "./pages/DashboardCompras";
import Profile from "./pages/Profile";
import ListClients from "./pages/Clients/ListClients";
import FormClients from "./pages/Clients/FormClients";
import ListEndClients from "./pages/EndClients/ListEndClients";
import FormEndClients from "./pages/EndClients/FormEndClients";
import ListProformas from "./pages/Proformas/ListProformas";
import FormProformas from "./pages/Proformas/FormProformas";
import ListProducts from "./pages/Products/ListProducts";
import FormProducts from "./pages/Products/FormProducts";
import ListTaxes from "./pages/Config/ListTaxes";
import ListTypeTaxpayer from "./pages/Config/ListTypeTaxpayer";
import ListExchangeRateHistory from "./pages/Config/ListExchangeRateHistory";
import ListPaymentMethods from "./pages/Config/ListPaymentMethods";
import ListInvoices from "./pages/Invoices/ListInvoices";
import ListAuditLogs from "./pages/Config/ListAuditLogs";
import ListConfigWithholdings from "./pages/Config/ListConfigWithholdings";
// (2026-07-02) SENIAT Fase 1: catálogos oficiales GGTIC.GIT.00.02 v1.4
// (solo visualización, restringido a admin/auditor)
import CatalogosSeniat from "./pages/Config/CatalogosSeniat";
import ListCompanyUsers from "./pages/CompanyUsers/ListCompanyUsers";
import FormCompanyUsers from "./pages/CompanyUsers/FormCompanyUsers";
import ListWithholdings from "./pages/Withholdings/ListWithholding";
import FormWithholding from "./pages/Withholdings/FormWithholding";
import ListDispatchGuide from "./pages/DispatchGuide/ListDispatchGuide";
import FormDispatchGuide from "./pages/DispatchGuide/FormDispatchGuide";
import ListCreditNote from "./pages/CreditNote/ListCreditNote";
import ListCreditDebit from "./pages/DebitNote/ListDebitNote";
import SalesBook from "./pages/SalesBook/SalesBook";
import PublicDocument from "./pages/PublicDocument";
// (2026-05-17) FIND-2: página 404 para rutas no registradas (antes: pantalla en blanco)
import NotFound from "./pages/NotFound";
SalesBook
// Req 1 (2026-05-13): Facturación de terceros — contratos
import ListContracts from "./pages/Contracts/ListContracts";
// (2026-05-15) Gestión de Terceros del emisor (reutiliza Clientes)
import ListTerceros from "./pages/Terceros/ListTerceros";
import FormTerceros from "./pages/Terceros/FormTerceros";
// (2026-05-21) Cobranza mensual (solo admin)
import ListBillingRulesPage from "./pages/Billing/ListBillingRulesPage";
import FormBillingRulesPage from "./pages/Billing/FormBillingRulesPage";
import ListBillingHistoryPage from "./pages/Billing/ListBillingHistoryPage";
import DetailBillingHistoryPage from "./pages/Billing/DetailBillingHistoryPage";
// (2026-06-08) Módulo de Compras
import GastosPage from "./pages/Compras/GastosPage";
// (2026-06-09) MAESTRO de Proveedores (lista pagina + formulario pagina),
// identico a Clientes. (El modal monolitico ProveedoresPage.js queda en disco
// solo como referencia.)
import ProveedoresList from "./pages/Compras/ProveedoresList";
import ProveedoresForm from "./pages/Compras/ProveedoresForm";
// (2026-06-09) MAESTRO de Compras (lista pagina + formulario pagina), identico a Facturas.
// (El modal monolitico ComprasPage.js queda en disco solo como referencia.)
import ComprasList from "./pages/Compras/ComprasList";
import CompraForm from "./pages/Compras/CompraForm";
// (2026-06-09) Maestro de Ordenes de Compra (lista pagina + formulario pagina)
import OrdenesCompraList from "./pages/Compras/OrdenesCompraList";
import OrdenCompraForm from "./pages/Compras/OrdenCompraForm";
import LibroComprasPage from "./pages/Compras/LibroComprasPage";
// Seguridad
import PrivateRoute from "./components/PrivateRoute";
import RoleRoute from "./components/RoleRoute";

function App() {
  return (
    <Router>
      <AuthProvider>
        {/* 🔔 Toast global (Axios y AuthContext lo usan) */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          pauseOnHover
          newestOnTop
        />

        <Routes>
          {/* =================== */}
          {/* Rutas públicas */}
          {/* =================== */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/document/:type/:id" element={<PublicDocument />} />

          {/* =================== */}
          {/* Rutas privadas */}
          {/* =================== */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/compras"
            element={
              <PrivateRoute>
                <DashboardCompras />
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />

          {/* Pre-facturación */}
          <Route
            path="/proformas"
            element={
              <PrivateRoute>
                <ListProformas />
              </PrivateRoute>
            }
          />
          <Route
            path="/proformas/create"
            element={
              <PrivateRoute>
                <FormProformas />
              </PrivateRoute>
            }
          />
          <Route
            path="/proformas/edit"
            element={
              <PrivateRoute>
                <FormProformas />
              </PrivateRoute>
            }
          />
          {/* Pre-facturación */}
          <Route
            path="/salesBook"
            element={
              <PrivateRoute>
                <SalesBook />
              </PrivateRoute>
            }
          />
          {/* Clientes (admin) */}
          {/* (2026-05-18) Lista de clientes: el auditor accede a la MISMA
              vista que el admin pero en modo SOLO lectura (sin Crear/Editar
              /Eliminar — gestionado por `canManage` en ListClients y por el
              bloqueo de escrituras de auditor en el backend). Crear/Editar
              siguen restringidos a admin (rutas /empresas/create|edit). */}
          <Route
            path="/empresas"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "auditor"]}>
                  <ListClients />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/empresas/create"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin"]}>
                  <FormClients />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/empresas/edit"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin"]}>
                  <FormClients />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          {/* Clientes finales */}
          <Route
            path="/clients"
            element={
              <PrivateRoute>
                <RoleRoute roles={["operador_admin", "operador", "visor", "auditor"]}>
                  <ListEndClients />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/clients/create"
            element={
              <PrivateRoute>
                <RoleRoute roles={["operador_admin", "operador"]}>
                  <FormEndClients />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/clients/edit"
            element={
              <PrivateRoute>
                <RoleRoute roles={["operador_admin", "operador"]}>
                  <FormEndClients />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          {/* (2026-06-08) Módulo de Compras */}
          {/* (2026-06-09) Proveedores reconstruida como MAESTRO: lista (pagina) +
              formulario (pagina) en /create y /edit, identico a Clientes. */}
          <Route path="/compras/proveedores" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador"]}>
              <ProveedoresList />
            </RoleRoute></PrivateRoute>} />
          <Route path="/compras/proveedores/create" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador"]}>
              <ProveedoresForm />
            </RoleRoute></PrivateRoute>} />
          <Route path="/compras/proveedores/edit" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador"]}>
              <ProveedoresForm />
            </RoleRoute></PrivateRoute>} />
          <Route path="/compras/gastos" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador"]}>
              <GastosPage />
            </RoleRoute></PrivateRoute>} />
          {/* (2026-06-09) Compras reconstruida como MAESTRO: lista (pagina) +
              formulario (pagina) en /create y /edit, identico a Facturas.
              Editar solo aplica al estatus 'borrador'. */}
          <Route path="/compras/facturas" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador"]}>
              <ComprasList />
            </RoleRoute></PrivateRoute>} />
          <Route path="/compras/facturas/create" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador"]}>
              <CompraForm />
            </RoleRoute></PrivateRoute>} />
          <Route path="/compras/facturas/edit" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador"]}>
              <CompraForm />
            </RoleRoute></PrivateRoute>} />
          {/* (2026-06-09) OC reconstruida como MAESTRO: lista (pagina) +
              formulario (pagina) en /create y /edit, identico a Proformas. */}
          <Route path="/compras/ordenes" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador"]}>
              <OrdenesCompraList />
            </RoleRoute></PrivateRoute>} />
          <Route path="/compras/ordenes/create" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador"]}>
              <OrdenCompraForm />
            </RoleRoute></PrivateRoute>} />
          <Route path="/compras/ordenes/edit" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador"]}>
              <OrdenCompraForm />
            </RoleRoute></PrivateRoute>} />
          <Route path="/compras/libro" element={
            <PrivateRoute><RoleRoute roles={["admin", "operador_admin", "operador", "auditor"]}>
              <LibroComprasPage />
            </RoleRoute></PrivateRoute>} />

          {/* Productos */}
          <Route
            path="/products"
            element={
              <PrivateRoute>
                <RoleRoute roles={["operador_admin", "operador", "admin", "visor", "auditor"]}>
                  <ListProducts />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/products/create"
            element={
              <PrivateRoute>
                <RoleRoute roles={["operador_admin", "operador", "admin"]}>
                  <FormProducts />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/products/edit"
            element={
              <PrivateRoute>
                <RoleRoute roles={["operador_admin", "operador", "admin"]}>
                  <FormProducts />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          {/* Configuración */}
          <Route
            path="/taxes"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "visor", "auditor"]}>
                  <ListTaxes />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/taxpayer"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "operador", "visor", "auditor"]}>
                  <ListTypeTaxpayer />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/config-withholdings"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "operador", "visor", "auditor"]}>
                  <ListConfigWithholdings />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/config-exchange-rate-history"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "operador", "visor", "auditor"]}>
                  <ListExchangeRateHistory />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/config-payment-methods"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "operador", "visor", "auditor"]}>
                  <ListPaymentMethods />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          {/* (2026-07-02) SENIAT Fase 1: catálogos oficiales GGTIC.GIT.00.02
              v1.4 — SOLO visualización y SOLO admin/auditor (el backend
              además responde 403 a cualquier otro rol). */}
          <Route
            path="/catalogos-seniat"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "auditor"]}>
                  <CatalogosSeniat />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          {/* Facturación */}
          <Route
            path="/invoices"
            element={
              <PrivateRoute>
                <ListInvoices />
              </PrivateRoute>
            }
          />
          {/* Notas de Crédito */}
          <Route
            path="/credit-note"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "operador", "visor", "auditor"]}>
                  <ListCreditNote />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          {/* Notas de Débito */}
          <Route
            path="/debit-note"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "operador", "visor", "auditor"]}>
                  <ListCreditDebit />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          {/* Retenciones */}
          <Route
            path="/withholdings"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "operador", "visor", "auditor"]}>
                  <ListWithholdings />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/withholdings/create"
            element={
              <PrivateRoute>
                <FormWithholding />
              </PrivateRoute>
            }
          />
        {/* Guia de despacho */}
          <Route
            path="/dispatch-guide"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "operador", "visor", "auditor"]}>
                  <ListDispatchGuide />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/dispatch-guide/create"
            element={
              <PrivateRoute>
                <FormDispatchGuide />
              </PrivateRoute>
            }
          />

          {/* Req 1 v4 (2026-05-13): Contratos de Terceros — admin/auditor (acceso global),
              operador_admin/visor (solo si su cliente es emisor; el sidebar maneja la
              visibilidad por predicate, esta route solo restringe por rol). */}
          <Route
            path="/contracts"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "visor", "auditor"]}>
                  <ListContracts />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          {/* (2026-05-15) Terceros del emisor — reutiliza Clientes.
              Lista/modal: operador_admin/operador/visor.
              Form (crear/editar): SOLO operador_admin. */}
          <Route
            path="/terceros"
            element={
              <PrivateRoute>
                <RoleRoute roles={["operador_admin", "operador", "visor"]}>
                  <ListTerceros />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/terceros/create"
            element={
              <PrivateRoute>
                <RoleRoute roles={["operador_admin"]}>
                  <FormTerceros />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/terceros/edit"
            element={
              <PrivateRoute>
                <RoleRoute roles={["operador_admin"]}>
                  <FormTerceros />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          {/* Auditoría */}
          <Route
            path="/auditlogs"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin"]}>
                  <ListAuditLogs />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          {/* Usuarios empresa */}
          <Route
            path="/company-users"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "visor", "auditor"]}>
                  <ListCompanyUsers />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/company-users/create"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "operador"]}>
                  <FormCompanyUsers />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/company-users/edit"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin", "operador_admin", "operador"]}>
                  <FormCompanyUsers />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          {/* (2026-05-21) Cobranza — solo admin */}
          <Route
            path="/billing-rules"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin"]}>
                  <ListBillingRulesPage />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/billing-rules/create"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin"]}>
                  <FormBillingRulesPage />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/billing-rules/edit"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin"]}>
                  <FormBillingRulesPage />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/billing-history"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin"]}>
                  <ListBillingHistoryPage />
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/billing-history/detail"
            element={
              <PrivateRoute>
                <RoleRoute roles={["admin"]}>
                  <DetailBillingHistoryPage />
                </RoleRoute>
              </PrivateRoute>
            }
          />

          {/* (2026-05-17) FIND-2: catch-all — cualquier ruta no registrada
              muestra la página 404 con diseño Sirius en vez de pantalla en blanco. */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;